import styled from 'styled-components';
export const HeaderWrapper = styled.header `
  position: relative;
  font-family: var(--font-family);
  display: flex;
  flex-direction: column;
  justify-content: center;
  z-index: var(--z-index-400-header, 400);

  //TODO: Remover apos update do oraculo PR: https://github.com/olxbr/oraculo-front/pull/47
  #oraculo .combobox-wrapper div[role='combobox'] span {
    box-shadow: 0 0 0 var(--border-width-hairline) var(--textinput-border-color-empty);
  }
  #oraculo .combobox-wrapper div[role='combobox'] span:hover {
    box-shadow: 0 0 0 var(--border-width-thin) var(--textinput-border-color-empty-hover);
  }
  #oraculo .combobox-wrapper div[role='combobox'] span:focus-within {
    box-shadow: 0 0 0 var(--border-width-thin) var(--color-secondary-medium);
  }

  //TODO: Remover apos update do oraculo PR: https://github.com/olxbr/oraculo-front/pull/47

  &.fixed {
    position: fixed;
    width: 100%;
    top: 0;
  }

  &.open {
    z-index: var(--z-index-700-overlay, 700);
  }

  &.is-loading {
    opacity: 0;
  }

  .profile-skeleton {
    border-radius: var(--border-radius-pill);
    border: 1px solid var(--color-neutral-90);
    display: none;

    @media all and (min-width: 840px) {
      display: block;
    }
  }

  &[data-newmaxwidth='true'] {
    width: 100%;
    border-bottom: 1px solid var(--color-neutral-100);
    padding: 0 var(--spacing-2);
    @media screen and (min-width: 841px) {
      padding: 0 var(--spacing-4);
    }
    @media screen and (min-width: 1025px) {
      padding: 0 72px;
    }
  }
`;
export const MainMenu = styled.nav `
  padding: 0 var(--spacing-3);
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: var(--color-neutral-70);
  min-height: 80px;
  border-bottom: 1px solid var(--color-neutral-90);

  &.show {
    position: fixed;
    background: var(--color-neutral-70);
    width: 100%;
    top: 0;
  }

  transition: transform var(--transition-duration-5) var(--transition-timing-ease-in-out);

  @media all and (max-width: 839px) {
    padding: var(--spacing-2);
  }

  &[data-newmaxwidth='true'] {
    width: 100%;
    max-width: 1632px;
    margin: 0 auto;
    padding: var(--spacing-2) 0;
    border-bottom: none;
  }
`;
export const PrimaryMenu = styled.div `
  display: flex;
  justify-content: space-between;
  flex-direction: row;

  width: 100%;
  max-width: 1272px;
  margin: 0 auto;

  &[data-newmaxwidth='true'] {
    max-width: 100%;
  }
`;
export const ColumnLeft = styled.div `
  display: flex;
  align-items: center;
  flex: 1;
  position: relative;

  .burger-menu {
    width: 48px;
    height: 48px;
    justify-content: start;

    @media all and (max-width: 359px) {
      width: 44px;
      height: 44px;
    }

    @media all and (min-width: 840px) {
      display: none;
    }
  }

  .header-go-back-button {
    margin-right: var(--spacing-1);
    @media all and (min-width: 840px) {
      display: none;
    }
  }
`;
export const ColumnRight = styled.div `
  display: flex;
  transition: all var(--transition-duration-5) var(--transition-timing-ease);
`;
export const LogoContainer = styled.span `
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  column-gap: 32px;
  font-size: var(--font-size-xxs);
  color: var(--color-neutral-130);

  @media all and (max-width: 359px) {
    width: 44px;
    height: 44px;
  }
`;
export const Links = styled.ul `
  display: flex;
  column-gap: var(--spacing-3);
  margin: 0;
  align-items: center;
  padding: 0;

  @media all and (max-width: 1024px) {
    column-gap: var(--spacing-2);
  }

  @media all and (max-width: 839px) {
    column-gap: var(--spacing-1);
    margin-left: var(--spacing-1);
  }

  @media all and (max-width: 599px) {
    column-gap: 0;
    margin-left: 0;
    padding: 0;
  }
`;
export const Item = styled.li `
  list-style: none;
  display: flex;
  align-items: center;

  @media (max-width: 839px) {
    & > a:not(.desapegar-button) {
      padding: 12px;
    }

    &.hide-notification {
      display: none;
    }
  }

  @media all and (max-width: 359px) {
    & > a:not(.link-ad-button) {
      padding: 10px;
    }
  }

  & > a {
    column-gap: var(--spacing-1);

    &:hover {
      text-decoration: none;
    }
  }

  .desapegar-button {
    color: var(--color-neutral-70);
    font-size: var(--font-size-xxs);
  }

  @media all and (max-width: 599px) {
    .desapegar-button {
      height: 32px;
      padding: var(--spacing-1) var(--spacing-2);
    }
  }

  @media all and (max-width: 839px) {
    &.professional-plan-item,
    &.my-ads-item {
      display: none;
    }

    &.has-navbar {
      display: none;
    }
  }
`;
export const LogoWrapper = styled.span `
  width: 24px;
  height: 24px;
`;
export const NotificationIconWrapper = styled.span `
  &[data-counter]:not([data-counter='0']) {
    max-width: 24px;
    display: inline-flex;
    position: relative;

    &:after {
      pointer-events: none;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: content-box;
      content: attr(data-counter);
      position: absolute;
      line-height: 19px;
      left: -8px;
      top: -8px;
      padding: 1px;
      background: #f78323;
      width: 17px;
      height: 17px;
      border-radius: 50%;
      color: #fff;
      font-weight: 700;
      font-size: 10px;
      text-align: center;
      pointer-events: none;
      animation: pop 1s ease forwards;
    }

    & svg {
      animation: bell-shake 1.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) 3;
      animation-delay: 1s;
      backface-visibility: hidden;
      transform-origin: top right;

      @keyframes bell-shake {
        0% {
          transform: rotate(0deg);
        }
        5% {
          transform: rotate(10deg);
        }
        10% {
          transform: rotate(-10deg);
        }
        15% {
          transform: rotate(10deg);
        }
        20% {
          transform: rotate(-10deg);
        }
        25% {
          transform: rotate(0deg);
        }
        75% {
          transform: rotate(0deg);
        }
        80% {
          transform: rotate(10deg);
        }
        85% {
          transform: rotate(-10deg);
        }
        90% {
          transform: rotate(10deg);
        }
        95% {
          transform: rotate(-10deg);
        }
        100% {
          transform: rotate(0);
        }
      }
    }

    @keyframes pop {
      0% {
        transform: scale(0);
      }

      25% {
        transform: scale(1.25);
      }

      50% {
        transform: scale(0.8);
      }

      75% {
        transform: scale(1.25);
      }

      100% {
        transform: scale(1);
      }
    }
  }
`;
export const Label = styled.span `
  @media all and (max-width: 1271px) {
    clip: rect(1px, 1px, 1px, 1px);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
    display: flex;
  }

  @media all and (max-width: 839px) {
    &.chat-label,
    &.notification-label {
      clip: initial;
      height: initial;
      overflow: initial;
      position: initial;
      white-space: initial;
      width: initial;
      display: initial;
    }
  }

  @media all and (max-width: 599px) {
    &.chat-label,
    &.notification-label {
      clip: rect(1px, 1px, 1px, 1px);
      height: 1px;
      overflow: hidden;
      position: absolute;
      white-space: nowrap;
      width: 1px;
      display: flex;
    }
  }
`;
export const SearchWrapper = styled.div `
  margin: 0 var(--spacing-3);
  width: 100%;

  &.has-navbar {
    margin: 0 var(--spacing-2);
  }

  @media all and (max-width: 839px) {
    &:not(.has-navbar) {
      display: none;

      #searchtext-input {
        display: none;
      }
    }
  }
`;
export const SearchFluidWrapper = styled.div `
  width: 100%;
  padding-top: var(--spacing-2);
  padding-left: var(--spacing-3);
  padding-right: var(--spacing-3);

  @media all and (min-width: 840px) {
    display: none;
  }

  @media all and (max-width: 839px) {
    padding-left: 0;
    padding-right: 0;
  }
`;
